export default __webpack_public_path__ + "195a5963e89a1ff0cf03c04a629bcea3.ttf";